import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Reminder } from './_types';

const readOnlyFields = [
  'created_at',
  'updated_at',
  '_stripePlanId',
  '_triggerSelectValue',
  'meta',
  'platform_id',
  'data_load_model',
  'user_plan_id',
  'copied_at',
  'copied_from_id',
  'copied_from_plan_id',
  'deleted_at',
  'payment_plan_name',
];

export const normalizeReminder = (reminder): Reminder => {
  return camelcaseKeys(reminder, { deep: true }) as Reminder;
};

export const denormalizeReminder = (reminder): Reminder => {
  const decamelized = decamelizeKeys(reminder, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  // Convert content array to string for message-based automations.
  // Some action types legitimately use arrays (trainer IDs, tags) and must be preserved.
  const arrayContentTypes = ['client-tag', 'close-out-visit', 'book-appointment'];
  const content = decamelized.content;
  const preserveContentArray =
    arrayContentTypes.includes(decamelized.custom_type) ||
    decamelized.reminder_type === 'book-appointment';
  if (Array.isArray(content) && !preserveContentArray) {
    decamelized.content = content[0] || '';
  }

  return {
    ...decamelized,
  } as Reminder;
};
